/**
 * nid.js — Egyptian National ID (14 digits) parser.
 * Reference (Python):
 *   century digit (index 0): 2→2000s, 3→2100s, else 1900s
 *   year2 (1..3), month (3..5), day (5..7)
 *   governorate (7..9)
 *   gender digit (index 12): odd=ذكر, even=أنثى
 */

export const GOV_CODES = {
  "01": "القاهرة", "02": "الإسكندرية", "03": "بورسعيد", "04": "السويس",
  "11": "دمياط", "12": "الدقهلية", "13": "الشرقية", "14": "القليوبية",
  "15": "كفر الشيخ", "16": "الغربية", "17": "المنوفية",
  "21": "الجيزة", "22": "بني سويف", "23": "الفيوم", "24": "المنيا",
  "25": "أسيوط", "26": "سوهاج", "27": "قنا", "28": "أسوان", "29": "الأقصر",
  "31": "البحر الأحمر", "32": "الوادي الجديد", "33": "مطروح",
  "34": "شمال سيناء", "35": "جنوب سيناء", "88": "المركز الرئيسي",
};

/**
 * Extract {birthdate, birth_place, gender} from a 14-digit Egyptian NID.
 * Returns null when the input is not a valid 14-digit NID.
 * birthdate is ISO-formatted "YYYY-MM-DD" (compatible with <input type="date">).
 */
export function extractFromNid(nid) {
  if (!nid) return null;
  const s = String(nid).trim();
  if (s.length !== 14 || !/^\d{14}$/.test(s)) return null;

  const centuryDigit = parseInt(s[0], 10);
  const year2 = parseInt(s.slice(1, 3), 10);
  const month = parseInt(s.slice(3, 5), 10);
  const day = parseInt(s.slice(5, 7), 10);

  let birthYear;
  // معيار الرقم القومي المصري: الرقم الأول 2 يعني مولود في القرن العشرين
  // (1900-1999)، والرقم 3 يعني القرن الحادي والعشرين (2000-2099) — وليس
  // العكس. هذا إصلاح لخطأ كان موجودًا (نُقِل بالخطأ من مصدر سابق) يُنتِج
  // سنوات ميلاد مستقبلية مستحيلة (مثل 2103) لأي طالب مولود بعد سنة 2000.
  if (centuryDigit === 2) birthYear = 1900 + year2;
  else if (centuryDigit === 3) birthYear = 2000 + year2;
  else birthYear = 1900 + year2;

  // Basic sanity checks on month/day — invalid → return null
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const govCode = s.slice(7, 9);
  const genderDigit = parseInt(s[12], 10);
  const gender = genderDigit % 2 === 1 ? "ذكر" : "أنثى";
  const birthdate = `${birthYear}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  const birth_place = GOV_CODES[govCode] || "";
  return { birthdate, birth_place, gender };
}
